import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.protokoll-liste';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleProtokollListeEffects {

    ProtokollListe$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PROTOKOLL_LISTE),
        mergeMap((x: ac.GetProtokollListeAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getProtokollListe().pipe(
                map((result: any) => {
                    return new ac.GetProtokollListeErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetProtokollListeFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleSqlService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleSqlService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleSqlService);
        }
        return this.service;
    }
}
